import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Observable } from 'rxjs';
import { CovanceGridColumn } from '../../../covance-ag-grid';
import { map } from 'rxjs/operators';
import { routeData } from '../../../shared/route-helpers';
import { SponsorStudySiteIdentity } from '../../sites/sponsor-study-site-identity';
import { ActivatedRoute } from '@angular/router';
import { SponsorRouteData } from '../../sponsor-route-data';
import { SponsorEQueryColumns } from '../sponsor-e-query-columns';
import { EQueryTab } from '../../../e-queries/models/e-query-tab.enum';
import { ExternalUserEQueriesFilterDefinitions } from '../../../e-queries/external-user-e-query-filter-definitions';
import { FilterFieldValue } from '../../../covance-filter';
import { ActivityLogger } from '../../../activities/activity-logger';

@Component({
    selector: 'sponsor-submitted-e-queries',
    template: require('./sponsor-submitted-e-queries.component.html'),
    styles: [require('./sponsor-submitted-e-queries.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SponsorSubmittedEQueriesComponent {
    public eQueryTab = EQueryTab.submitted;
    public columns$: Observable<CovanceGridColumn[]>;
    public filterDefs: FilterFieldValue[];
    constructor(sponsorEQueriesColumns: SponsorEQueryColumns,
                route: ActivatedRoute, sponsorRouteData: SponsorRouteData,
                externalUserEQueriesFilterDef: ExternalUserEQueriesFilterDefinitions,
                activityLogger: ActivityLogger,
    ) {
        this.filterDefs = externalUserEQueriesFilterDef.getSubmittedFilterDefinitions();
        const currentSiteIdentity = route.parent.data.pipe(
            map(d => d[routeData.selectedSiteIdentity] as SponsorStudySiteIdentity));
        this.columns$ = currentSiteIdentity.pipe(map((s) => sponsorEQueriesColumns.getSubmittedColumns(s.siteId, sponsorRouteData.snapshot.selectedStudy)));
        activityLogger.logActivity('Access a Query List View');
    }
}
